/**
 * @copyright    Copyright © 2019-2025 MiniVentureLab
 * @author       Kuldeep Rathore  <kuldeep@miniventurelab.com>
 * @package      Mesh Platform UI
 * @license      Proprietary
 * @description  Console
 * 
 * Vue Store for UI State and Localstorage Management
 */

import Vue from 'vue'
import Vuex from 'vuex'
import cache_ls from './cache_ls';
Vue.use(Vuex);

cache_ls.CURRENT_USER_ID = cache_ls.get_current_user_id_ls();
const store = new Vuex.Store({
  state: {
    isOnGide: true,
    token: cache_ls.get_auth_token_ls(cache_ls.CURRENT_USER_ID) || null,
    user_data: cache_ls.get_user_data_ls(cache_ls.CURRENT_USER_ID) || null,
    acc_id: cache_ls.get_acc_id_ls(cache_ls.CURRENT_USER_ID) || null,
    selected_group: cache_ls.get_selected_group_ls(cache_ls.CURRENT_USER_ID) || null,
    participant_id: null,
    fcm_push_token: cache_ls.fcm_push_token_get_ls(cache_ls.CURRENT_USER_ID) || null,
    relevant_message: cache_ls.get_relevant_message_ls(cache_ls.CURRENT_USER_ID) || null,
    chatgrp_list:cache_ls.get_chatgrp_list_ls(cache_ls.CURRENT_USER_ID) || null,
    chatgrp_icon_list:cache_ls.get_chatgrp_icon_list_ls(cache_ls.CURRENT_USER_ID) || null, 
    unread_chatgrp:cache_ls.get_unread_chatgrp_ls(cache_ls.CURRENT_USER_ID) || {},     
    userContactList: cache_ls.getUserContactList_ls(cache_ls.CURRENT_USER_ID) || null,
    snackbar:null,
    inviteGroupId:cache_ls.get_inviteCode_ls() || null,
    pinned_message:null,
    pinned_msg_id:null,
    selected_tag: null,
    listener_group_action_response:null,
    listener_chatmsg_add_response:null,
    listener_chatgrp_edit_response:null,
    listener_group_delete_response:null,
    listener_user_edit_response:null,
    listener_chatmsg_delete_response:null,
    listener_media_data_response:null,
    listener_card_locked_response: cache_ls.get_locked_card_list_ls(cache_ls.CURRENT_USER_ID) || null,
    listener_card_moved_response:null,
    listener_topic_moved_response:null,
    selected_card_to_edit: cache_ls.get_selected_card_to_edit_ls(cache_ls.CURRENT_USER_ID) || null,
    selected_board: cache_ls.get_selected_board_ls(cache_ls.CURRENT_USER_ID) || null,
    group_info: null,
    height:cache_ls.client_height_get_ls() || null,
    search_bar:null,
    external_app_shared_text:null,
    deeplink_message_id:null,
    deeplink_card_id:null,
    selected_group_for_media:null,
    board_back_button: null,
    app_version: cache_ls.get_app_version_ls(cache_ls.CURRENT_USER_ID) || null,
    refreshChatGrpList:null,
    refreshSubscribeAccountIdList:null,
    listener_calendar_event_add_response:null,
    listener_calendar_event_edit_response:null,
    o2o_invites: null,
    group_participants: cache_ls.get_group_participants_lf() || null, // contains the participants of a group 
    group_participant_count: cache_ls.getGrpParticipantCount(),
    frame: cache_ls.get_frame()
  },
  getters: {
    getIsOnGide(state) {
      return state.isOnGide
    },
    loggedIn(state) {
      return state.token !== null;
    },
    getToken(state) {
     return state.token;
    },
    getSocket(state){
      return state.socket;
    },
    userData(state) {
       return state.user_data;
    },
    getAccId(state){
      return state.acc_id;
    },
    async selectedGroup(state){
      return await state.selected_group;
    },
    selectedDeeplinkMessage(state){
      return state.deeplink_message_id;
    },
    getSelectedDeeplinkBoardCard(state){
      return state.deeplink_card_id;
    },
    participantId(state){
      return state.participant_id;
    },
    async inviteGroupId(state){
      return await state.inviteGroupId;
    },
    externalAppSharedText(state){
      return state.external_app_shared_text;
    },
    fcm_push_token(state){
      return state.fcm_push_token;
    },    
    relevantMessage(state){
      return state.relevant_message;
    },
    async getChatgrpList(state) {
      return await state.chatgrp_list;
    },
    async getChatgrpIconList(state) {
      return await state.chatgrp_icon_list;
    },
    async getUnreadChatgrp(state) {
      return await state.unread_chatgrp;
    },
    async getUserContactList(state){
      return await state.userContactList;
    },
    getGroupDetailListener(state){
      return state.group_info;
    },
    getSnackBar(state){
      return state.snackbar;
    },
    getClientDeviceHeight(state){
      return state.height;
    },
    getSearchBar(state){
      return state.search_bar;
    },
    getPinnedMessage(state){
      return state.pinned_message;
    },
    getScrollToPinnedmsg(state){
      return state.pinned_msg_id;
    },
    getListenerGroupActionResponse(state){
      return state.listener_group_action_response;
    },
    getListenerChatmsgAddResponse(state){
      return state.listener_chatmsg_add_response;
    },
    getListenerChatgrpEditResponse(state){
      return state.listener_chatgrp_edit_response;
    },
    getListenerGroupDeleteResponse(state){
      return state.listener_group_delete_response;
    },
    getListenerUserEditResponse(state){
      return state.listener_user_edit_response;
    },
    getListenerChatmsgDeleteResponse(state){
      return state.listener_chatmsg_delete_response;
    },
    getListenerMediaDataResponse(state){
      return state.listener_media_data_response;
    },
    async getListenerCardLockedResponse(state){
      return await state.listener_card_locked_response;
    },
    getListenerCardMovedResponse(state){
      return state.listener_card_moved_response;
    },
    getListenerTopicMovedResponse(state){
      return state.listener_topic_moved_response;
    },
    getSelectedTag(state){
      return state.selected_tag;
    },
    getSelectedGroupForMedia(state){
      return state.selected_group_for_media;
    },
    getBoardBackButton(state){
      return state.board_back_button;
    },
    getAppVersion(state){
      return state.app_version;
    },
    getRefreshChatGrpList(state){
      return state.refreshChatGrpList;
    },
    getRefreshSubscribeAccountIdList(state){
      return state.refreshSubscribeAccountIdList;
    },
    getSelectedCardToEdit(state){
      return state.selected_card_to_edit;
    },
    getSelectedBoard(state){
      return state.selected_board;
    },
    getListenerEventAddResponse(state){
      return state.listener_calendar_event_add_response;
    },
    getListenerEventEditResponse(state){
      return state.listener_calendar_event_edit_response;
    },
    geto2oInvite(state){
      return state.o2o_invites;
    },
    async getGroupParticipants(state) {
      return await state.group_participants
    },
    async getGroupParticipantCount(state) {
      return await state.group_participant_count
    },
    async getFrame (state) {
      return await state.frame
    }
  },
  mutations: {
    setSocket(state, socket){
      state.socket = socket;
    },
    setAuthToken(state, token) {
      cache_ls.set_auth_token_ls(token);    
      state.token = token;
    },
    setUserProfile(state, user_data) {
      cache_ls.CURRENT_USER_ID = user_data.user_id;
      if(cache_ls.CURRENT_USER_ID){
        cache_ls.set_current_user_id_ls(cache_ls.CURRENT_USER_ID);
      }
      else{
        cache_ls.CURRENT_USER_ID = cache_ls.get_current_user_id_ls();
      }

      cache_ls.set_user_data_ls(user_data);
      state.user_data = user_data;
    },
    setAccId(state, acc_id){
      cache_ls.set_acc_id_ls(acc_id);
      state.acc_id = acc_id;
    },
    async setSelectedGroup(state, selected_group) {
      await cache_ls.set_selected_group_ls(selected_group);
      state.selected_group = selected_group;
    },
    setParticipantId(state, participant_id) {
      state.participant_id = participant_id;
    },
    async setInviteGroupId(state, group_id){
      state.inviteGroupId = group_id;
      await cache_ls.set_inviteCode_ls(group_id);
    },
    setSelectedDeeplinkMessage(state, deeplink_message_id){
      state.deeplink_message_id = deeplink_message_id;
    },
    setSelectedDeeplinkBoardCard(state, deeplink_card_id){
      state.deeplink_card_id = deeplink_card_id;
    },
    setExternalAppSharedText(state, external_app_shared_text){
      state.external_app_shared_text = external_app_shared_text;
    },
    setFcmPushToken(state, fcm_push_token){
      state.fcm_push_token = fcm_push_token;
      cache_ls.fcm_push_token_set_ls(fcm_push_token);
    },    
    setRelevantMessage(state, relevant_message) {
      cache_ls.set_relevant_message_ls(relevant_message);
      state.relevant_message = relevant_message;
    },
    async setChatgrpList(state, chatgrp_list) {
      await cache_ls.set_chatgrp_list_ls(chatgrp_list);
      state.chatgrp_list = chatgrp_list;
    },
    async setChatgrpIconList(state, chatgrp_icon_list) {
      await cache_ls.set_chatgrp_icon_list_ls(chatgrp_icon_list);
      state.chatgrp_icon_list = chatgrp_icon_list;
    },
    async setUnreadChatgrp(state, unread_chatgrp) {
      await cache_ls.set_unread_chatgrp_ls(unread_chatgrp);
      state.unread_chatgrp = unread_chatgrp;
    },
    async setUserContactList(state, userContactList){
      await cache_ls.setUserContactList_ls(userContactList);
      state.userContactList = userContactList;      
    },
    setGroupDetailListener(state, group_info){
      state.group_info = group_info;
    },
    setSnackBar(state, snackbar={msg:'', show:false}){
      state.snackbar = snackbar; //snack bar should be globally.
    },
    setClientDeviceHeight(state, height){
      cache_ls.client_height_set_ls(height);
      state.height = height;
    },
    setSearchBar(state, enable=false){
      state.search_bar = enable;
    },
    setPinnedMessage(state, pinned_message){
      state.pinned_message = pinned_message;
    },
    setScrollToPinnedmsg(state, pinned_msg_id){
      state.pinned_msg_id = pinned_msg_id;
    },
    setListenerGroupActionResponse(state, response){
      state.listener_group_action_response = response;
    },
    setListenerChatmsgAddResponse(state, response){
      state.listener_chatmsg_add_response = response;
    },
    setListenerChatgrpEditResponse(state, response){
      state.listener_chatgrp_edit_response = response;
    },
    setListenerGroupDeleteResponse(state, response){
      state.listener_group_delete_response = response;
    },
    setListenerUserEditResponse(state, response){
      state.listener_user_edit_response = response;
    },
    setListenerChatmsgDeleteResponse(state, response){
      state.listener_chatmsg_delete_response = response;
    },
    setListenerMediaDataResponse(state, response){
      state.listener_media_data_response = response;
    },
    async setListenerCardLockedResponse(state, response){
      await cache_ls.set_locked_card_list_ls(response);
      state.listener_card_locked_response = response;
    },
    async setListenerCardMovedResponse(state, response){
      state.listener_card_moved_response = response;
    },
    async setListenerTopicMovedResponse(state, response){
      state.listener_topic_moved_response = response;
    },
    setSelectedTag(state, selected_tag){
      return state.selected_tag = selected_tag;
    },
    setSelectedGroupForMedia(state, group){
      state.selected_group_for_media = group;
    },
    setBoardBackButton(state, button){
      state.board_back_button = button;
    },
    destroyLocalStore(state, val) {
      state=val;
    },
    setAppVersion(state, app_version) {
      cache_ls.set_app_version_ls(app_version);
      state.app_version = app_version;
    },
    setRefreshChatGrpList(state, refreshChatGrpListFlag){
      state.refreshChatGrpList = refreshChatGrpListFlag;
    },
    setRefreshSubscribeAccountIdList(state, refreshListFlag){
      state.refreshSubscribeAccountIdList = refreshListFlag;
    },
    setSelectedCardToEdit(state, selected_card_to_edit){
      cache_ls.set_selected_card_to_edit_ls(selected_card_to_edit);
      state.selected_card_to_edit = selected_card_to_edit;
    },
    setSelectedBoard(state, selected_board){
      cache_ls.set_selected_board_ls(selected_board);
      state.selected_board = selected_board;
    },
    async setListenerCalendarEventAddResponse(state, response){
      state.listener_calendar_event_add_response = response;
    },
    async setListenerCalendarEventEditResponse(state, response){
      state.listener_calendar_event_edit_response = response;
    },
    async seto2oInvite(state, invite){
      state.o2o_invites = invite;
    },
    async setGroupParticipants(state, groupParticipants){
      state.group_participants = groupParticipants;
      cache_ls.set_group_participants_lf(groupParticipants)
    },
    async setGroupParticipantCount(state, groupParticipantCount){
      state.group_participant_count = groupParticipantCount;
      cache_ls.setGrpParticipantCount(groupParticipantCount)
    },
    async setFrame(state, frame) {
      state.frame = frame
      cache_ls.set_frame(frame)
    } 
  },
  actions: {
    destroyLocalStore(context) {
      return new Promise((resolve) => {
        cache_ls.destroy_data_ls();
        context.commit('destroyLocalStore', null);
        resolve(true);
      });
    }
  }
});

export default store;
